import React, { useEffect, useState } from "react";

//Images
import loginImage from "../../assets/images/Login.svg";
import lockImage from "../../assets/images/lock.svg";
/////
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
// import { fetchSystemConfiguration } from "../../redux/slices/CommonSlice";
import { useAuth } from "../../context/AuthContext";
import LogoImg from "../../assets/images/Main-Logo.png";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/slices/UserSlice";
import HelmetBase from "../../components/HelmetBase";

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// const phnRegex = /^[0-9]{8,12}$/;
// const phnRegex = /^[0-9]{9}$/;
const phnRegex = /^5[0-9]{8}$/;

const Login = () => {
  const { systemConfiguration } = useSelector((state) => state.commonStore);
  const token = localStorage.getItem("token");

  const email = localStorage.getItem("email");
  const password = localStorage.getItem("password");
  const rememberMe = localStorage.getItem("rememberMe");

  const { t } = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { loginAction, error } = useAuth();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const formValidations = Yup.object({
    email: Yup.string()
      .trim()
      .test(
        "email",
        t("Please enter a valid email or Phone number"),
        (value) => {
          return emailRegex.test(value) || phnRegex.test(value);
        }
      )
      .required(t("Email or Phone Number is Required")),
    password: Yup.string()
      .trim()
      .required(t("Password is Required"))
      .min(8, t("Password must be at least 8 characters")),
  });

  const formik = useFormik({
    initialValues: {
      email: rememberMe == "true" ? email : "",
      password: rememberMe == "true" ? password : "",
      rememberMe: rememberMe == "true" ? true : false,
    },
    validationSchema: formValidations,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setLoading(true);
        if (values.rememberMe) {
          localStorage.setItem("email", values.email);
          localStorage.setItem("password", values.password);
          localStorage.setItem("rememberMe", values.rememberMe);
        } else {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          localStorage.removeItem("rememberMe");
        }

        // dispatch(login(values))
        //   .then((res) => {
        //     // console.log("RES", res);
        //     if (res?.payload?.status == 1) {
        //       setSubmitting(false);
        //       setLoading(false);
        //       navigate("/dashboard");
        //     }
        //   })
        //   .catch(() => {
        //     setLoading(false);
        //   });
        const obj = {
          ...values,
          device_type: "web",
          device_token: localStorage.getItem("firebaseToken"),
        }
        loginAction(obj)
          .then(() => {
            setSubmitting(false);
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } catch (err) {
        console.log(err);
      }
    },
  });

  // useEffect(() => {
  //   async function fetchConfig() {
  //     await dispatch(fetchSystemConfiguration());
  //     console.log("systemConfiguration dispatched", systemConfiguration);
  //   }
  //   fetchConfig();
  // }, []);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <>
      <HelmetBase title={`${t("Sign in")}`} name={`${t("Sign in")}`} />
      <div className="container-fluid">
        <div className="row login-container">
          <div className="col-md-6 left-side">
            <img
              src={loginImage}
              alt="Login Illustration"
              className="login-image"
            />
          </div>
          <div className="col-md-6 right-side">
            <div className="login-form">
              <div className="brand-logo d-flex justify-content-center mb-5">
                <Link to="/">
                  <img src={systemConfiguration?.logo} alt="Logo Images" />
                </Link>
              </div>
              <div className="head-contant">
                <div className="head-image">
                  <img src={lockImage} alt="" />
                </div>
                <div className="head-text">
                  <h1>{t("Sign in")}</h1>
                  <p>{t("Hi! Welcome back, you've been missed")}</p>
                </div>
              </div>
              {/* <button onClick={handleEnableNotifications}>Enable Notifications</button> */}
              <Form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder={`${t("Email or mobile phone number")} *`}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger">{formik.errors.email}</div>
                  )}
                </div>
                <div className="mb-2" style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    placeholder={`${t("Enter your password")} *`}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <Button
                    variant="link"
                    className="show-hide-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <i className="fa fa-eye"></i>
                    ) : (
                      <i className="fa fa-eye-slash"></i>
                    )}
                  </Button>

                  {formik.touched.password && formik.errors.password && (
                    <div className="text-danger">{formik.errors.password}</div>
                  )}
                </div>
                {/* {error && <div className="text-danger my-2">{error}</div>} */}
                <div className="d-flex justify-content-between mb-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      name="rememberMe"
                      checked={formik.values.rememberMe}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label className="form-check-label" htmlFor="rememberMe">
                      {t("Remember me")}
                    </label>
                  </div>

                  <Link to="/forgot-password" className="text-decoration-none">
                    {t("Forgot Password")}?
                  </Link>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading ? true : false}
                >
                  {loading ? t("Loading...") : t("Sign in")}
                </button>
                <p className="text-center mt-4">
                  {t("Don't have an account")}?{" "}
                  <Link to="/sign-up" className="text-decoration-none">
                    {t("Sign Up")}
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
